import { format } from 'date-fns'

export const formatDate = (date: Date | string | number, df: string = 'dd.MM.yyyy') => {
  return format(new Date(date), df)
}
